import { privateAxios } from 'services/api/privateAxios';

export const getCustomerStatus = () =>
  privateAxios({
    method: 'post',
    url: '/customer/getstatus',
  });
